import { ButtonSlide } from '@vfit/shared/atoms';
import { purify } from '@vfit/shared/themes';
import { IButtonCardProps } from './buttonCard.models';
import { getButtonStyle } from './buttonCard.utils';
import { Container, TextDiv, Title, Description } from './buttonCard.style';

const ButtonCard = ({ title, description, buttonLabel, onClick, cardStyle }: IButtonCardProps) => {
  const [pTitle, pDescription] = purify([title, description]);

  const buttonStyle = getButtonStyle(cardStyle?.buttonVariant?.toLowerCase());

  return (
    <Container {...cardStyle}>
      <TextDiv>
        <Title {...cardStyle} dangerouslySetInnerHTML={{ __html: pTitle || '' }} />
        {pDescription && (
          <Description {...cardStyle} dangerouslySetInnerHTML={{ __html: pDescription }} />
        )}
      </TextDiv>
      <ButtonSlide {...buttonStyle} label={buttonLabel} onClick={onClick} />
    </Container>
  );
};

export default ButtonCard;

